import { helper } from "@ember/component/helper";

export function projectColorClass(color) {
  switch (color[0]) {
    case "skyblue":
      return "bg-indigo-700";
    case "midnightblue":
      return "bg-blue-600";
    case "lightcoral":
      return "bg-red-600";
    case "mediumaquamarine":
      return "bg-green-100";
    case "sandybrown":
      return "bg-orange-600";
    case "lemonchiffon":
      return "bg-yellow-600";
    case "rebeccapurple":
      return "bg-rebeccapurple-700";
    case "silver":
    default:
      return "bg-gray-400";
  }
}

export default helper(projectColorClass);
